import type { EmployeeDesignation } from '../types';
import { hasOfficeOpsPrivileges } from './employeeDesignations';

/** Admins, EAs, and office managers may open the all-projects time report in Project Hub. */
export function canViewAllProjectsTimeReport(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  return hasOfficeOpsPrivileges(args.designations);
}

/** Precon billable / non-billable toggle on Project Hub — admins, employees, EAs, and office managers. */
export function canEditPreconBillableStatus(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin' || args.authRole === 'employee') return true;
  return hasOfficeOpsPrivileges(args.designations);
}
